import { TableColumn } from "../table/TableColumn";

const ModesColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "name",
        isDefault: true
    }
];

export default ModesColumns;
